import Vue from "vue";
import Router from "vue-router";
//解决路由重复问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location);
};
//刚进来的初始页
const Initial = () => import("@/components/login/Initial");
//全局页面
const Index = () => import("@/components/platform/index/Index");
//登录
const Login = () => import("@/components/login/Login");
//系统用户
const SystemUser = () =>import("@/components/platform/systemMange/SystemUser.vue");
//角色权限
const RoleList = () => import("@/components/platform/systemMange/RoleList.vue");
//添加、编辑角色权限
const UpdateRole = () => import("@/components/platform/systemMange/UpdateRole.vue");
//登录日志
const LoginLog = () => import("@/components/platform/loginLog/LoginLog.vue");
//指纹比对
const AudioSearch = () => import("@/components/platform/wholeNetwork/AudioSearch");
//指纹比对-详情
const AudioSearchDetail = () => import("@/components/platform/wholeNetwork/AudioSearchDetail");
//指纹录入
const AudioInsert = () => import("@/components/platform/wholeNetwork/AudioInsert");
//统计-指纹比对
const SearchCharts = () => import("@/components/platform/census/SearchCharts");
//统计-指纹录入
const InsertCharts = () => import("@/components/platform/census/InsertCharts");

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login", // 登录页面
      name: "Login",
      component: Login
    },
    {
      path: "/", // 首页
      redirect: "/initial"
    },
    { path: "*", redirect: "/" }, // 这里就是配置没有的路由和默认的路由
    {
      path: "/index",
      name: "Index",
      component: Index,
      children: [
        {
          path: "/initial",
          name: "initial",
          component: Initial
        },
        {
          path: "/systemUser",
          name: "systemUser",
          component: SystemUser
        },
        {
          path: "/roleList",
          name: "roleList",
          component: RoleList
        },
        {
          path: "/updateRole",
          name: "updateRole",
          component: UpdateRole
        },
        {
          path: "/loginLog",
          name: "loginLog",
          component: LoginLog
        },
        {
          path: "/searchCharts",
          name: "searchCharts",
          component: SearchCharts
        },
        {
          path: "/insertCharts",
          name: "insertCharts",
          component: InsertCharts
        },
        //指纹对比
        {
          path: '/audioSearch',
          name: 'audioSearch',
          component:AudioSearch,
        },
        {
          path: '/audioSearch/audioSearchDetail/:id',
          name: 'audioSearchDetail',
          component: AudioSearchDetail,
        },
        //指纹录入
        {
          path: '/audioInsert',
          name: 'audioInsert',
          component:AudioInsert,
        },
     //===========================
        {
          path: "/goTo",
          name: "goTo",
          component: () =>
            import(
              /* webpackChunkName: "monitor" */ "../components/public/Goto.vue"
            ),
          meta: { title: "跳转页", auth: true }
        }
      ]
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js